export const PRODUCTS = [
  { id: 0, name: 'Not used' },
  {
    id: 2,
    name: 'Evolution Lights',
    text: 'The channel supports up to 75Ft of Lights. (200Ft per controller)'
  },
  {
    id: 1,
    name: 'Classic Lights',
    text: 'The channel supports up to 250Ft of Lights. (200Ft per controller)'
  }
];
